import { ComponentProps } from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = ComponentProps<typeof Sonner>;

export const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          "bg-white! p-3! rounded-2xl! text-slate-950! border-slate-200! shadow-lg!",
        description: "text-slate-500!",
        actionButton:
          "bg-slate-900! text-slate-50! px-2! py-1! rounded-md! font-medium!",
        cancelButton:
          "bg-slate-100! text-slate-500! px-2! py-1! rounded-md! font-medium!",
        title: "text-lg! font-bold!",
      },
    }}
    {...props}
  />
);
